import React from 'react';

import { AdAttributeNames } from '@gumtree/shared/src/model/seller-other-ads-model';
import { BaseAttribute } from '@gumtree/shared/src/types/attributes';
import { L1CategoryId, getL1CategoryIdBySeoName } from '@gumtree/shared/src/util/category-mapping';

import { qaAttribute } from '../../utils/qa-service';
import { formatNumber } from '../../utils/string-service';
import { Attributes } from './attributes';

export const mapAttributesByCategory = ({
    attributes,
    l1CategoryId,
}: {
    attributes?: BaseAttribute[];
    l1CategoryId: L1CategoryId;
}) => {
    if (!attributes) {
        return undefined;
    }

    const attributesMap = {} as AdAttributeNames;
    attributes.forEach(({ key, ...rest }) => {
        attributesMap[key] = { ...rest };
    });

    if (l1CategoryId === getL1CategoryIdBySeoName('cars-vans-motorbikes')) {
        //motors
        const {
            vehicle_registration_year: { value: year } = {},
            vehicle_mileage: { value: mileage } = {},
            seller_type: { value: sellerType } = {},
            vehicle_fuel_type: { value: fuelType } = {},
            vehicle_engine_size: { value: engineSizeValue, unit: engineSizeUnit } = {},
        } = attributesMap;
        return (
            <Attributes {...qaAttribute('tile-attributes')}>
                {year && <span {...qaAttribute('motors-year')}>{year}</span>}
                {mileage && (
                    <span {...qaAttribute('motors-mileage')}>
                        {formatNumber(mileage)} {mileage > 1 ? 'miles' : 'mile'}
                    </span>
                )}
                {sellerType && <span {...qaAttribute('motors-seller-type')}>{sellerType}</span>}
                {fuelType && <span {...qaAttribute('motors-fuel-type')}>{fuelType}</span>}
                {engineSizeValue && engineSizeUnit && (
                    <span {...qaAttribute('motors-engine-size')}>
                        {Number(engineSizeValue).toLocaleString()} {engineSizeUnit}
                    </span>
                )}
            </Attributes>
        );
    } else if (l1CategoryId === getL1CategoryIdBySeoName('flats-houses')) {
        //property
        const {
            available_date: { value: availableDate = undefined } = {},
            property_type: { value: propertyType } = {},
            property_number_beds: { value: numberOfbeds } = {},
            seller_type: { value: sellerType } = {},
        } = attributesMap;
        return (
            <Attributes>
                {sellerType && <span>{sellerType}</span>}
                {availableDate && <span>Date available: {availableDate}</span>}
                {propertyType && <span>{propertyType}</span>}
                {numberOfbeds && (
                    <span>
                        {numberOfbeds} Bed{numberOfbeds > 1 && 's'}
                    </span>
                )}
            </Attributes>
        );
    } else if (l1CategoryId === getL1CategoryIdBySeoName('pets')) {
        //pets
        const {
            pet_date_of_birth: { value: birthday } = {},
            pet_rehome_ready_date: { value: readyDate } = {},
        } = attributesMap;
        return (
            <Attributes showSeparator={false}>
                {birthday && (
                    <div>
                        <b>Age</b>: {birthday}
                    </div>
                )}
                {readyDate && (
                    <div>
                        <b>Ready to leave</b>: {readyDate}
                    </div>
                )}
            </Attributes>
        );
    } else if (l1CategoryId === getL1CategoryIdBySeoName('jobs')) {
        //jobs
        const {
            job_contract_type: { value: contractType } = {},
            recruiter: { value: recruiter } = {},
        } = attributesMap;
        return (
            <Attributes>
                {contractType && <span>{contractType}</span>}
                {recruiter && <span>Recruitment {recruiter}</span>}
            </Attributes>
        );
    } else {
        return undefined;
    }
};
